(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-demo"] && !Shopify.designMode) return;
  try {
    
   document.querySelectorAll('.modal-toggle-btn').forEach(function(toggle) {
      toggle.addEventListener('click', function(e) {
          e.preventDefault();
          var elementID = this.getAttribute("data-modal-toggle");
          var modal = document.querySelector('.modal#' + elementID);
          modal.classList.toggle('is-visible');
          if (modal.classList.contains('is-visible')) {
              document.body.classList.add('overflow-stop');
          } else {
              document.body.classList.remove('overflow-stop');
          }
      });
  });
  document.querySelectorAll(".modal-close, .modal-overlay").forEach(function(closeElement) {
      closeElement.addEventListener("click", function(e) {
          e.preventDefault();
          document.querySelectorAll(".modal").forEach(function(pane) {
              pane.classList.remove("is-visible");
          });
          document.body.classList.remove('overflow-stop');
      });
  });
  document.querySelectorAll('.scrollbar').forEach(function(scrollbar) {
      scrollbar.addEventListener("click", function(e) {
          e.stopPropagation();
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-popup"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.modal-toggle-btn').forEach(function(toggle) {
    toggle.addEventListener('click', function(e) {
        e.preventDefault();
        var elementID = this.getAttribute("data-modal-toggle");
        var modal = document.querySelector('.modal#' + elementID);
        modal.classList.toggle('is-visible');

        if (modal.classList.contains('is-visible')) {
            modal.classList.add('z-index'); // Add z-index class when visible
            document.body.classList.add('overflow-stop');
        } else {
            document.body.classList.remove('overflow-stop');
            setTimeout(function() {
                modal.classList.remove('z-index'); // Remove z-index class after 0.5 seconds
            }, 500);
        }
    });
});

document.querySelectorAll(".modal-close, .modal-overlay").forEach(function(closeElement) {
    closeElement.addEventListener("click", function(e) {
        e.preventDefault();
        document.querySelectorAll(".modal").forEach(function(pane) {
            pane.classList.remove("is-visible");
            document.body.classList.remove('overflow-stop');
            setTimeout(function() {
                pane.classList.remove('z-index'); // Remove z-index class after 0.5 seconds
            }, 500);
        });
    });
});

document.querySelectorAll('.scrollbar').forEach(function(scrollbar) {
    scrollbar.addEventListener("click", function(e) {
        e.stopPropagation();
    });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-mobile"] && !Shopify.designMode) return;
  try {
    
      document.querySelectorAll('.account-drawer-toggle, .account-drawer-overlay ,.account-drawer-drawer-close,.account-drawer .menu-item.modal-toggle-btn').forEach(function(element) {
        element.addEventListener('click', function() {
            document.querySelector('.account-drawer-toggle').classList.toggle('clicked');
            document.querySelector('.account-drawer-drawer-close').classList.toggle('clicked');
            document.querySelector('.account-drawer-overlay').classList.toggle('active');
            document.querySelector('.account-drawer ').classList.toggle('active');
            document.body.classList.toggle('overflow');
          
        });
    });

document.addEventListener("DOMContentLoaded", function () {
  "use strict";

  // Array to keep track of parent menu heights
  const parentHeights = [];

  // Function to adjust the menu height
  function adjustMenuHeight() {
    const menu = document.querySelector('.menu');
    if (menu) {
      // Reset the menu height to auto before calculating the new height
      menu.style.height = 'auto';
      const currentSubMenu = document.querySelector('.offcanvas-submenu.in-view');
      if (currentSubMenu) {
        const currentSubMenuHeight = currentSubMenu.scrollHeight; // Use scrollHeight for full height
        menu.style.height = currentSubMenuHeight + 'px';
      }
    } else {
      console.warn('Menu element not found.');
    }
  }

  // Call the function on window load and resize to adjust menu height dynamically
  window.addEventListener('load', adjustMenuHeight);
  window.addEventListener('resize', adjustMenuHeight);

  const offcanvasSubmenus = document.querySelectorAll(".offcanvas-submenu");
  const subMenuToggles = document.querySelectorAll(".has-children .sub-menu-toggle");

  subMenuToggles.forEach(toggle => {
    toggle.addEventListener("click", function (event) {
      const currentSubMenu = this.closest("li").querySelector(".offcanvas-submenu");
      const parentMenu = this.parentElement.parentElement.parentElement;

      if (currentSubMenu) {
        currentSubMenu.classList.toggle("in-view");

        if (currentSubMenu.classList.contains("in-view")) {
          // Store the height of the parent menu before opening the submenu
          const parentHeight = parentMenu.offsetHeight;
          parentHeights.push(parentHeight); // Store the height
          parentMenu.classList.add("off-view");
          adjustMenuHeight(); // Adjust height when submenu is opened
        } else {
          parentMenu.classList.remove("off-view");
          adjustMenuHeight(); // Adjust height when submenu is closed
        }
        event.preventDefault();
      }
    });
  });

  offcanvasSubmenus.forEach(submenu => {
    const backButton = document.createElement("li");
    backButton.classList.add("back-btn");
    backButton.innerHTML = `<a href="#">${translations.back}</a>`;
    submenu.prepend(backButton);
    backButton.addEventListener("click", function (event) {
      const parentMenu = this.parentElement.parentElement.parentElement;
      const currentSubmenu = this.parentNode;
      currentSubmenu.classList.remove("in-view");
      parentMenu.classList.remove("off-view");

      // Check if there's a stored height to revert to
      if (parentHeights.length > 0) {
        const previousHeight = parentHeights.pop(); // Get the last stored height
        parentMenu.style.height = previousHeight + 'px'; // Set the height to the parent height
      } else {
        adjustMenuHeight(); // Reset height to auto if no parent height is stored
      }

      event.preventDefault();
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

document.addEventListener("DOMContentLoaded", () => {
  const dropdownTrigger = document.querySelector(".tool-bar-desktop.profile-dropdown-menu");
  const dropdownMenu = document.querySelector(".myaccount-dropdown.logged-in-dropdown");

  function handleDropdownLogic() {
    if (dropdownTrigger && dropdownMenu) {
      dropdownTrigger.addEventListener("click", (event) => {
        event.stopPropagation(); // Prevent click from bubbling to document
        const isVisible = dropdownMenu.style.visibility === "visible";

        if (isVisible) {
          dropdownMenu.style.visibility = "hidden";
          dropdownMenu.style.opacity = "0";
        } else {
          dropdownMenu.style.visibility = "visible";
          dropdownMenu.style.opacity = "1";
        }
      });

      // Close the dropdown when clicking outside
      document.addEventListener("click", () => {
        dropdownMenu.style.visibility = "hidden";
        dropdownMenu.style.opacity = "0";
      });

      // Prevent closing when clicking inside the dropdown
      dropdownMenu.addEventListener("click", (event) => {
        event.stopPropagation();
      });
    } else {
      console.error("Dropdown trigger or menu not found.");
    }
  }

  function handleResize() {
    const viewportWidth = window.innerWidth;

    if (viewportWidth < 997) {
      handleDropdownLogic();
    } else {
      // Clean up event listeners if the screen is resized above 997px
      if (dropdownTrigger) {
        dropdownTrigger.removeEventListener("click", handleDropdownLogic);
      }
      document.removeEventListener("click", handleDropdownLogic);
    }
  }

  // Initial check
  handleResize();

  // Add resize event listener
  window.addEventListener("resize", handleResize);
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"] && !Shopify.designMode) return;
  try {
    
   document.querySelectorAll('.modal-toggle-btn').forEach(function(toggle) {
      toggle.addEventListener('click', function(e) {
          e.preventDefault();
          var elementID = this.getAttribute("data-modal-toggle");
          var modal = document.querySelector('.modal#' + elementID);
          modal.classList.toggle('is-visible');
          if (modal.classList.contains('is-visible')) {
              document.body.classList.add('overflow-stop');
          } else {
              document.body.classList.remove('overflow-stop');
          }
      });
  });
  document.querySelectorAll(".modal-close, .modal-overlay").forEach(function(closeElement) {
      closeElement.addEventListener("click", function(e) {
          e.preventDefault();
          document.querySelectorAll(".modal").forEach(function(pane) {
              pane.classList.remove("is-visible");
          });
          document.body.classList.remove('overflow-stop');
      });
  });
  document.querySelectorAll('.scrollbar').forEach(function(scrollbar) {
      scrollbar.addEventListener("click", function(e) {
          e.stopPropagation();
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["upload-prescription"] && !Shopify.designMode) return;
  try {
    
   document.querySelectorAll('.modal-toggle-btn').forEach(function(toggle) {
      toggle.addEventListener('click', function(e) {
          e.preventDefault();
          var elementID = this.getAttribute("data-modal-toggle");
          var modal = document.querySelector('.modal#' + elementID);
          modal.classList.toggle('is-visible');
          if (modal.classList.contains('is-visible')) {
              document.body.classList.add('overflow-stop');
          } else {
              document.body.classList.remove('overflow-stop');
          }
      });
  });
  document.querySelectorAll(".modal-close, .modal-overlay").forEach(function(closeElement) {
      closeElement.addEventListener("click", function(e) {
          e.preventDefault();
          document.querySelectorAll(".modal").forEach(function(pane) {
              pane.classList.remove("is-visible");
          });
          document.body.classList.remove('overflow-stop');
      });
  });
  document.querySelectorAll('.scrollbar').forEach(function(scrollbar) {
      scrollbar.addEventListener("click", function(e) {
          e.stopPropagation();
      });
  });

  } catch(e) { console.error(e); }
})();
})();
